export var PageType;
(function (PageType) {
    PageType["Content"] = "content";
    PageType["Events"] = "events";
    PageType["News"] = "news";
    PageType["Resources"] = "resources";
    PageType["CGeogMembers"] = "cGeogMember";
})(PageType || (PageType = {}));
